<template>
    <div class="mc-root notification-panel">
        <header class="notification-panel__heading">
            <div><h2 id="notification-title" class="t-title-3">Notifiche</h2><p class="t-label">Le attività destinate a te</p></div>
            <v-btn icon aria-label="Chiudi notifiche" @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
        </header>
        <div class="notification-panel__tools">
            <v-btn-toggle :value="inbox.history ? 1 : 0" mandatory dense class="mc-vseg" @change="changeHistory">
                <v-btn :aria-pressed="!inbox.history">Da fare</v-btn><v-btn :aria-pressed="inbox.history">Storico</v-btn>
            </v-btn-toggle>
            <v-btn icon aria-label="Aggiorna notifiche" :loading="inbox.loading" @click="reload"><v-icon>mdi-refresh</v-icon></v-btn>
        </div>
        <v-btn v-if="manager" text color="primary" :to="{ name: 'GestioneNotifiche' }" @click="$emit('close')"><v-icon left small>mdi-cog-outline</v-icon>Gestisci notifiche</v-btn>
        <v-btn text color="primary" :to="{ name: 'LeMieAttivita' }" @click="$emit('close')">Le mie attività<v-icon right small>mdi-arrow-right</v-icon></v-btn>
        <v-btn text :to="{ name: 'PromemoriaNotifiche' }" @click="$emit('close')">Promemoria rinviati</v-btn>
        <p v-if="inbox.stale" class="notification-panel__warning t-caption" role="status"><v-icon small>mdi-alert-outline</v-icon>Dati non aggiornati. La disponibilità è da verificare.</p>
        <p v-else-if="inbox.verified_at" class="notification-panel__updated t-caption">Verificato {{ updatedAt(inbox.verified_at) }}</p>
        <mc-state-message v-if="inbox.error" state="error" title="Notifiche non aggiornate" :text="inbox.error" @retry="reload" />
        <mc-state-message v-if="inbox.loading && !inbox.loaded" state="loading" :height="120" />
        <ul v-else-if="inbox.items.length" class="notification-panel__list" aria-label="Elenco notifiche">
            <notification-item v-for="item in inbox.items" :key="`${item.id}:${item.revision}`" :item="item" @seen="seen" @open="$emit('close')" />
        </ul>
        <mc-state-message v-else-if="!inbox.error && inbox.loaded" state="empty" :title="emptyTitle" :text="emptyText" />
        <footer v-if="inbox.page > 1 || inbox.has_next" class="notification-panel__pagination">
            <v-btn text :disabled="inbox.page === 1 || inbox.loading" @click="loadPage(inbox.page - 1)">Precedenti</v-btn>
            <span>Pagina {{ number(inbox.page, 0) }}</span>
            <v-btn text :disabled="!inbox.has_next || inbox.loading" @click="loadPage(inbox.page + 1)">Successive</v-btn>
        </footer>
    </div>
</template>
<script>
import McStateMessage from "../../assets/mecom/vue/McStateMessage.vue";
import { number, updatedAt } from "../../assets/mecom/js/format.mjs";
import NotificationItem from "./NotificationItem.vue";
import { canManage } from "./admin/rules.mjs";
export default {
    name: "NotificationPanel",
    components: { McStateMessage, NotificationItem },
    data: () => ({ visibleItems: new Map(), seenTimer: null, ownerEpoch: null }),
    computed: {
        manager() { return canManage(this.$store.getters.userdata); },
        inbox() { return this.$store.state.notifications; },
        emptyTitle() { return this.inbox.stale ? "Disponibilità da verificare" : this.inbox.history ? "Nessuna attività nello storico" : "Nessuna attività da fare"; },
        emptyText() { return this.inbox.stale ? "Non è ancora disponibile una lettura aggiornata." : "Qui compaiono le notifiche destinate al tuo account o al tuo gruppo."; },
    },
    mounted() { this.ownerEpoch = this.inbox.epoch; this.$store.dispatch("notifications/load", { work: this.$work, page: 1, history: false }); },
    beforeDestroy() { clearTimeout(this.seenTimer); this.flushSeen(); },
    methods: {
        number, updatedAt,
        reload() { this.$store.dispatch("notifications/load", { work: this.$work }); },
        loadPage(page) { this.flushSeen(); this.$store.dispatch("notifications/load", { work: this.$work, page }); },
        changeHistory(value) { this.flushSeen(); this.$store.dispatch("notifications/load", { work: this.$work, history: value === 1, page: 1 }); },
        seen(item) {
            this.visibleItems.set(item.id, item); clearTimeout(this.seenTimer);
            this.seenTimer = setTimeout(this.flushSeen, 700);
        },
        flushSeen() {
            const items = [...this.visibleItems.values()]; this.visibleItems.clear();
            if (items.length && this.ownerEpoch === this.inbox.epoch) {
                for (let offset = 0; offset < items.length; offset += 25) this.$store.dispatch("notifications/acknowledge", { work: this.$work, items: items.slice(offset, offset + 25) });
            }
        },
    },
};
</script>
